import { getSafeLandingLink, isLandingEntryPath } from './utils/landingPage';
import type { LandingApiMode } from './utils/landingPage';

function resetLandingScopedSession() {
  // 新 code 的接口模式必须由 indexNew/index 实际探测，不能在请求完成前假定为旧版。
  sessionStorage.removeItem('landingApiMode');
  sessionStorage.removeItem('landingApiModeCode');
  sessionStorage.removeItem('serviceLink');
  sessionStorage.removeItem('searchParams');
  sessionStorage.removeItem('searchIptValue');
}

const storedLandingCode = sessionStorage.getItem('landingCode');
const landingEntryPath = isLandingEntryPath(window.location.pathname);
const routeParams = new URLSearchParams(window.location.search);
// 只有首页和嵌入式首页的 code 才是落地页编码；/product?code=... 中的 code 是商品编码。
const routeLandingCode = landingEntryPath
  ? routeParams.get('code')?.trim() ?? ''
  : '';
const routeFrom = landingEntryPath ? routeParams.get('from')?.trim() ?? '' : '';
const storedFrom = sessionStorage.getItem('from')?.trim() ?? '';
if (routeLandingCode && routeLandingCode !== storedLandingCode) {
  // 在 React 页面初始化筛选 state 之前先清理上一条落地页的会话数据，避免首次请求串页。
  resetLandingScopedSession();
}
let landingCode = routeLandingCode || storedLandingCode;
if (routeLandingCode) sessionStorage.setItem('landingCode', routeLandingCode);
if (landingEntryPath) {
  if (routeFrom) sessionStorage.setItem('from', routeFrom);
  else sessionStorage.removeItem('from');
}
let serviceLink = getSafeLandingLink(sessionStorage.getItem('serviceLink') ?? undefined);
let uc = sessionStorage.getItem('uc');
let _token = localStorage.getItem('token');
let landingApiMode = sessionStorage.getItem('landingApiMode');
let landingApiModeCode = sessionStorage.getItem('landingApiModeCode');
const landingFrom = routeFrom || (!landingEntryPath ? storedFrom : '');

function isLandingApiMode(value: string | null): value is LandingApiMode {
  return value === 'legacy' || value === 'cardOrderLp';
}

class Main {
  pageBgStyle = {
    background: 'url("/pic/pic_page_bg.png")',
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#f1f1f1',
  };
  // shopId: string = 'TN-whALACBx';
  shopId: string = landingCode ? landingCode : '';
  landingApiMode: LandingApiMode =
    landingApiModeCode === landingCode && isLandingApiMode(landingApiMode) ? landingApiMode : 'legacy';
  landingApiModeResolved: boolean =
    !landingEntryPath && landingApiModeCode === landingCode && isLandingApiMode(landingApiMode);
  serviceLink?: string = serviceLink ? serviceLink : '';
  token: string = _token ?? '';
  // 广州移动通道商id
  supId: string = '1667093255927742465';
  // 公众号APPID
  appId = 'wx325d2f7c68fc6349';
  // 符合调取中移协议的接口数据
  protocolList = ['1706874456928157697'];
  // 西藏移动通道商id
  xzSupIds = ['1871755097503260673', '1957715627849629698'];
  // 唯一码
  uc = uc ? uc : '';

  // 微信用户授权CODE 在登录成功后获取OPENID
  code?: string;
  from?: string = landingFrom || undefined;
  // 微信用户授权OPENID 在登录成功后获取OPENID
  openId?: string;

  // 是否ios14 签名有问题
  isIos14: boolean = false;
  // 是ios14以上需要保存初始url
  enterUrl: string = '';

  setShopId(code: string) {
    const normalizedCode = code.trim();
    if (!normalizedCode) return;

    const changed = normalizedCode !== this.shopId;
    this.shopId = normalizedCode;
    sessionStorage.setItem('landingCode', normalizedCode);

    if (changed) {
      // 页面配置、筛选条件和接口模式都只对当前落地页有效，切换链接时不能串用。
      this.landingApiMode = 'legacy';
      this.landingApiModeResolved = false;
      this.serviceLink = '';
      resetLandingScopedSession();
    }
  }

  setLandingApiMode(mode: LandingApiMode) {
    this.landingApiMode = mode;
    this.landingApiModeResolved = true;
    sessionStorage.setItem('landingApiMode', mode);
    sessionStorage.setItem('landingApiModeCode', this.shopId);
  }

  init() {
    let ua = window.navigator.userAgent.toLowerCase();
    const ver = ua.match(/cpu iphone os (.*?) like mac os/);
    this.isIos14 = ver ? Number(ver?.[1].split('_')[0]) >= 14 : false;
  }
}

const main = new Main();
export default main;
